import { memo } from 'react'
import { clsx } from 'clsx'

interface AvatarProps {
  name: string
  src?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
  showStatus?: boolean
  isOnline?: boolean
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}

export const Avatar = memo(function Avatar({ name, src, size = 'md', className, showStatus, isOnline }: AvatarProps) {
  const sizeClasses = {
    sm: 'w-7 h-7 text-[11px]',
    md: 'w-10 h-10 text-sm',
    lg: 'w-14 h-14 text-lg',
  }

  const statusDotSize = {
    sm: 'w-2 h-2 border',
    md: 'w-3 h-3 border-2',
    lg: 'w-3.5 h-3.5 border-2',
  }

  if (src) {
    return (
      <div className={clsx('relative flex-shrink-0', className)}>
        <img
          src={src}
          alt={name}
          className={clsx('rounded-full object-cover', sizeClasses[size])}
        />
        {showStatus && (
          <span className={clsx('absolute bottom-0 right-0 rounded-full border-white', statusDotSize[size], isOnline ? 'bg-success' : 'bg-gray-300')} />
        )}
      </div>
    )
  }

  return (
    <div className={clsx('relative flex-shrink-0', className)}>
      <div
        className={clsx(
          'rounded-full bg-bg-subtle flex items-center justify-center font-semibold text-text-secondary',
          sizeClasses[size]
        )}
      >
        {getInitials(name)}
      </div>
      {showStatus && (
        <span className={clsx('absolute bottom-0 right-0 bg-success rounded-full border-white', statusDotSize[size])} />
      )}
    </div>
  )
})
